import React from 'react';
import { Box, Flex } from '@chakra-ui/react';

interface SegmentedOption {
  value: string;
  label: string;
}

interface SegmentedProps {
  value: string;
  onChange: (v: string) => void;
  options: SegmentedOption[];
  accent?: string;
  size?: 'xs' | 'sm';
}

/** Toggle segmentado (pílula) reusável — base|competência, sintético|analítico, etc. */
export const Segmented = ({
  value,
  onChange,
  options,
  accent = '#1B88F5',
  size = 'xs',
}: SegmentedProps) => (
  <Flex bg="rgba(15,23,42,0.05)" borderRadius="lg" p="3px" gap="2px">
    {options.map(opt => {
      const on = opt.value === value;
      return (
        <Box
          key={opt.value}
          as="button"
          px={size === 'sm' ? 3.5 : 3}
          py={1}
          borderRadius="md"
          fontSize={size === 'sm' ? 'sm' : 'xs'}
          fontWeight={700}
          whiteSpace="nowrap"
          transition="all 0.15s"
          color={on ? '#0F172A' : '#64748B'}
          bg={on ? 'white' : 'transparent'}
          boxShadow={on ? `0 1px 4px ${accent}40` : 'none'}
          onClick={() => onChange(opt.value)}
        >
          {opt.label}
        </Box>
      );
    })}
  </Flex>
);
